import {chiaveSport} from './icone';
import {coloriDiscipline} from '../../moduli/leggi';

/**
 * Il colore di ogni disciplina, e i tre stati di ogni livello del menu.
 *
 * I valori vengono dal PSD "menu1_modifiche_billionbet", letti alla
 * risoluzione vera e non a occhio. Non sono decorazione: nel menu lo sport
 * SELEZIONATO prende il proprio colore come fondo, ed e' cosi' che si capisce
 * dove si e'. Un menu tutto grigio e' un elenco; questo e' una mappa.
 *
 * La chiave e' la stessa di `chiaveSport`, quella che sceglie anche l'icona:
 * una sola funzione riconosce lo sport, due cose la usano. Se domani arriva
 * una disciplina nuova basta aggiungerla a PER_NOME in icone.js e qui, e non
 * c'e' un terzo posto da ricordare.
 */

/* Le diciassette prese pari pari dal PSD. */
const DAL_PSD = {
  calcio:    '#4c9d2f',   // Soccer
  tennis:    '#757136',   // tennis
  basket:    '#9f700a',   // Basketball
  pallavolo: '#b78c1f',   // Volleyball
  pallamano: '#93842d',   // Handball
  hockey:    '#7d7eab',   // Hockey
  baseball:  '#0d5851',   // Baseball
  football:  '#377b77',   // American Football
  rugby:     '#2d9283',   // Rugby
  cricket:   '#ac3c73',   // Cricket
  golf:      '#79853c',   // Golf
  pingpong:  '#926c92',   // Ping-pong
  bowling:   '#674778',   // Snooker
  freccette: '#5f2a6b',   // Dard
  pugilato:  '#185a7d',   // Boxing
  ciclismo:  '#768693',   // Biking
  motori:    '#98a4af',   // Motorsport
};

/*
 * Le discipline che il nostro catalogo ha e il PSD non aveva: il foglio
 * descriveva l'offerta di un altro fornitore. Questi SEI colori li ho scelti
 * io, presi comunque dalla tavolozza del PSD fra quelli rimasti liberi, in
 * modo che due sport vicini nel menu non si somiglino.
 *
 * Sono l'unica cosa inventata in tutto il file: se non convincono si cambiano
 * qui, una riga ciascuno.
 */
const SCELTI_DA_NOI = {
  mma:      '#671b4d',   // era Badminton
  aussie:   '#3f6d32',   // era Futsal
  esport:   '#373e5b',   // era Waterpolo
  ippica:   '#b5a36a',   // era Beach Volley
  atletica: '#7ba6bb',   // era Curling
};

/*
 * NIENTE riga per Lacrosse, e non e' una dimenticanza. `chiaveSport` non lo
 * riconosce - non sta in PER_NOME e non ha un'icona - quindi torna 'generico',
 * e un colore appeso a una chiave che non arriva mai sarebbe un campo
 * scollegato: sembra configurato e non serve a niente. Lacrosse prende il
 * grigio come ogni sport che non sappiamo disegnare. Il giorno che avra'
 * un'icona, si aggiunge in icone.js e qui, insieme.
 */

const COLORI = {...DAL_PSD, ...SCELTI_DA_NOI};

/* Quando lo sport non si riconosce. Grigio di proposito: un colore a caso
   farebbe sembrare una disciplina quello che e' solo un buco nei dati. */
const GENERICO = '#5b646d';

/**
 * Il colore di uno sport, dal nodo del catalogo.
 *
 * Prima quello che ha scelto la skin (Sito › Sport › Menu sport › colori,
 * una riga per disciplina), poi quello di serie qui sopra. I colori di serie
 * stanno anche nel catalogo («diSerie»), cosi' il backoffice li mostra.
 */
export function coloreSport(sport, dalCatalogo) {
  const chiave = chiaveSport(sport);
  let dellaSkin;
  try {
    dellaSkin = coloriDiscipline()[chiave];
  } catch (e) {
    dellaSkin = undefined;
  }
  /* Dopo la skin, il colore che manda il catalogo per quello sport, se ne
     manda uno (`color`): la scelta della skin vince su tutto. */
  const catalogo = dalCatalogo || (sport && sport.color);
  return dellaSkin || catalogo || COLORI[chiave] || GENERICO;
}

/**
 * I tre stati di ogni livello, dal PSD.
 *
 * Il bordo e' lo stesso per tutti - sopra scuro, sotto chiaro - ed e' quello
 * che fa sembrare le righe incise invece che stampate.
 */
export const BORDO_SOPRA = '#13191d';
export const BORDO_SOTTO = '#363d44';

export const STATI = {
  sport: {
    fondo:      '#232a30',
    sopra:      '#2d363e',
    // `scelto` non c'e': lo sport selezionato prende il PROPRIO colore.
    testo:      '#c8c8c8',
    testoAcceso:'#ffffff',
  },
  nazione: {
    fondo:      '#283341',
    sopra:      '#313e4e',
    scelto:     '#1c2939',
    testo:      '#c8c8c8',
    testoAcceso:'#ffffff',
  },
  campionato: {
    fondo:      '#5b646d',
    sopra:      '#3a464c',
    scelto:     '#3a464c',
    testo:      '#c8c8c8',
    testoAcceso:'#ffffff',
    // L'unico posto dove il testo scelto non e' bianco: il campionato
    // selezionato si accende di ciano perche' il fondo non cambia rispetto
    // al passaggio del mouse, e senza questo i due stati sarebbero uguali.
    testoScelto:'#4ee8de',
  },
};

export default coloreSport;
